import * as React from 'react';
import * as styles from './Sticky.css';
import { clsx } from 'clsx';

interface IStickyProps {
  className?: string;
  dataName?: string;
}

export const Sticky: React.FC<React.PropsWithChildren<IStickyProps>> = ({ children, className, dataName }) => {
  return (
    <div className={clsx(styles['sticky'], className)} data-name={dataName}>
      {children}
    </div>
  );
};
